import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';
import LogroForm from "../components/Forms/LogroForm.js";  // Asegúrate de crear este componente
import Swal from "sweetalert2";
import logroService from "../services/logrosServices.js"; // Asegúrate de tener este servicio
import courseService from "../services/courseService.js";
import useCustomDataTableStyles from "../components/estilosDeDataTable"; // Asegúrate de tener esta función
import types from '../services/types.js';
import utils from '../utils/generalFunctions';
import JornadaAnioPeriodoNivelCursoAsig from "../components/Filters/JornadaAnioPeriodoNivelCursoAsig.js";
import JornadaAnioPeriodoCursosMultiAsig from "../components/Filters/JornadaAnioPeriodoCursosMultiAsig.js";
import Loading from "../components/Loading.js";

const LogrosEstudiantes = () => {

     const [filters, setFilters] = useState({ // Estado para los filtros aplicados
            teacherId: '0',
            journeyId: '0',
            schoolYearId: '0',
            educationLevelId: '0',
            courseId: '0',
            isRecuperation:false
    });
    const filteReference = useRef(null);
    const [fullscreenXlModal, setFullscreenXlModal] = useState(false);
    const [paramLogros, setParamLogros] = useState({});
    const [logros, setLogros] = useState([]);
    const [selectedLogro, setSelectedLogro] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [BtnVer, setBtnVer] = useState('');
    const [evaluationTypeId, setEvaluationTypeId]= useState(types.evaluationTypes.ESCALA_VALORATIVA); 
    const [cmbEvaluationTypeId, setCmbEvaluationTypeId]= useState(types.evaluationTypes.ESCALA_VALORATIVA);
    const [showLoading, setShowLoading] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    // Cambia solo al abrir el modal (no en cada render), para forzar un LogroForm
    // fresco por apertura sin resetearlo mientras el usuario lo esta usando.
    const [formKey, setFormKey] = useState(0);

    // Selección de logros para clonar
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggledClearRows, setToggledClearRows] = useState(false);
    const [cloneModal, setCloneModal] = useState(false);
    const [cloneFilters, setCloneFilters] = useState({
        teacherId: '0',
        journeyId: '0',
        schoolYearId: '0',
        courseIds: [],
        schoolSubjectId: '0',
        periodId: '0',
    });
    const [cloneLoading, setCloneLoading] = useState(false);
    const cloneFilterReference = useRef(null);

    const toggleShow = () => {
        setFullscreenXlModal(!fullscreenXlModal);
        setSelectedLogro(null);
    }

    const openAddingModal = async (logro) => {
        setSelectedLogro(logro);
        setFullscreenXlModal(true);
        setBtnVer(false);
        setFormKey(Date.now());
    };

    // Limpia la selección de checkboxes de la tabla (cambia de logros listados
    // tras una nueva búsqueda, edición, eliminación o clonación).
    const clearRowSelection = () => {
        setSelectedRows([]);
        setToggledClearRows(prev => !prev);
    };

    const deleteLogroById = async(logro) => {
        Swal.fire({
            title: '¿Está seguro que desea eliminar este logro?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
          }).then(async(result) => {
            if (result.isConfirmed) {
                try{
                    await logroService.deleteLogroById(logro.achievementId);  
                    Swal.fire(
                        '¡Felicidades!',
                        'Logro eliminado exitosamente!',
                        'success'
                    );
                    fetchLogros();
                }catch(error){
                    Swal.fire(
                        "Ha ocurrido un error",
                        "Por favor intente más tarde",
                        "error"
                    );
                }
            }
        })
    }

    const fetchLogros = async (overrideParams) => {
        try {
            setShowLoading(true);
            let copyData;
            if(overrideParams){
                // Usado tras guardar un logro: busca exactamente con la ubicación
                // (año/periodo/grado/asignatura) que se usó al guardar, sin depender
                // de los filtros de búsqueda que puedan haber quedado desactualizados.
                copyData = utils.copy(overrideParams);
            }else{
                copyData = utils.copy(filters);
                const cursos = filteReference?.current?.getCursos();
                if(cursos.length>0){
                    copyData.gradeId = cursos.find(c=> String(c.courseId) === String(copyData.courseId))?.gradeId;
                }
                const educationLevels = filteReference?.current?.getEducationLeves();
                if(educationLevels.length>0){
                    copyData.evaluationTypeId = educationLevels.find(c=> String(c.educationLevelId) === String(copyData.educationLevelId))?.evaluationTypeId;
                }
            }
            setEvaluationTypeId(copyData.evaluationTypeId);
            setParamLogros(copyData);
            const response = await logroService.getLogros(copyData.courseId, copyData.schoolSubjectId, copyData.schoolYearId, copyData.periodId,copyData.evaluationTypeId,copyData.evaluationTypeId);
            const filtredData = response.filter(r=>r.evaluationTypeId===Number( copyData.evaluationTypeId));
            setLogros(filtredData);
            clearRowSelection();
        } catch (error) {
            console.error("Error al obtener los logros:", error);
        }
        setShowSearch(true);
        setShowLoading(false);// Cambia el estado a false una vez que los datos se carguen
    };

    // Al guardar un logro desde el modal, el usuario pudo haber cambiado de
    // grado/asignatura/año/periodo respecto a la búsqueda original. Sincroniza
    // los filtros visibles con esa ubicación (cuando existe un curso para ese
    // grado) y vuelve a buscar con los valores exactos que se acaban de guardar,
    // para siempre ver el listado de logros recién creados/editados.
    const searchAfterSave = async (savedData) => {
        if(!savedData){
            fetchLogros();
            return;
        }
        try {
            const cursos = await courseService.getCursos();
            const matched = cursos.find(c=> String(c.gradeId) === String(savedData.gradeId));
            if(matched){
                filteReference.current?.setFormValues({
                    journeyId: matched.journeyId,
                    schoolYearId: savedData.schoolYearId,
                    periodId: savedData.periodId,
                    educationLevelId: matched.educationLevelId,
                    courseId: matched.courseId,
                    schoolSubjectId: savedData.schoolSubjectId,
                });
                await fetchLogros({ ...savedData, courseId: matched.courseId });
            }else{
                console.error("No se encontró un curso asociado al grado del logro guardado; se mantiene la búsqueda actual.");
                fetchLogros();
            }
        } catch (error) {
            console.error("Error al sincronizar los filtros tras guardar el logro:", error);
            fetchLogros();
        }
    };

    const columns = [
        { 
            name: "N°", 
            selector: row => row.number, 
            sortable: true,
            grow:"0.5", 
            cell: (row, index) => <span>{index + 1}</span>, 
        },
        {
            name: 'Asignatura',
            selector: row => row.schoolSubjectName, 
            sortable: true,
            grow:"1",
        },
        {
            name: 'Grado',
            selector: row => row.gradeName, 
            sortable: true,
        },
        {
            name: 'Descripción',
            grow:"6",
            selector: row => row.description, 
            sortable: true,
        },
        {
            name: 'Desempeño',
            omit: (Number(evaluationTypeId)!==2),
            selector: row => row.evaluativeScaleName, 
            sortable: true,
        },
        {
            name: 'Proceso Evaluativo',
            omit:(Number(evaluationTypeId)!==1),
            selector: row => row.evaluationProcessName, 
            sortable: true,
        },
        {
            name: 'Año',
            selector: row => row.schoolYearName, 
            sortable: true,
        },
        {
            name: 'Periodo',
            selector: row => row.periodName, 
            sortable: true,
        },
        {
            name: 'Acciones',
            grow:"0.8",
            cell: (row) => (
                <div className="actions-container justify-content-between align-items-center">
                    <button
                        onClick={() => {openEditModal(row)}}
                        className="btn-edit btn-sm me-2"
                        title="Editar"
                    >
                        <i className="fas fa-edit"></i>
                    </button>
                    <button
                        onClick={() => deleteLogroById(row)}
                        className="btn-deactivate btn-sm"
                        title="Eliminar"
                    >
                        <i className="icon-deactivate fas fa-times"></i>
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const normalizeString = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
      };

    const filteredItems = logros?.filter((item) => {
        if (item) {
          const allData = `${item.schoolSubjectName} ${item.gradeName} ${item.description} ${item.evaluativeScaleName} ${item.schoolYearName} ${item.periodName}`;
          const normalizedFilterText = normalizeString(filterText);
          const normalizedItemName = normalizeString(allData);
          return normalizedItemName.includes(normalizedFilterText);
        }
        return item;
      });

    const openEditModal = async (logro) => {
        setSelectedLogro(logro);
        setFullscreenXlModal(true);
        setBtnVer(true);
        setFormKey(Date.now());
    };

    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
    };

    const openCloneModal = () => {
        setCloneFilters({
            teacherId: '0',
            journeyId: '0',
            schoolYearId: '0',
            courseIds: [],
            schoolSubjectId: '0',
            periodId: '0',
        });
        setCloneModal(true);
    };

    const closeCloneModal = () => {
        setCloneModal(false);
    };

    const handleCloneFilterChange = (newFilters) => {
        setCloneFilters(prev => ({
            ...prev,
            ...newFilters
        }));
    };

    const handleCloneSave = async () => {
        if (!cloneFilters.schoolYearId || String(cloneFilters.schoolYearId) === '0' ||
            !cloneFilters.periodId || String(cloneFilters.periodId) === '0' ||
            !cloneFilters.courseIds || cloneFilters.courseIds.length === 0 ||
            !cloneFilters.schoolSubjectId || String(cloneFilters.schoolSubjectId) === '0') {
            Swal.fire(
                "Campos Obligatorios",
                "Por favor seleccione año escolar, periodo, uno o más cursos y la asignatura de destino.",
                "error"
            );
            return;
        }

        const cursos = cloneFilterReference?.current?.getCursos() || [];
        const educationLevels = cloneFilterReference?.current?.getEducationLeves() || [];

        // Resuelve, para cada curso seleccionado, su grado y su tipo de evaluación
        // (vía el nivel educativo del curso) ya que este modal no tiene un combo
        // de Nivel Educativo explícito. Varios cursos pueden compartir el mismo
        // grado (secciones paralelas); se deduplica porque los logros se guardan
        // por grado, no por curso.
        const gradeIds = [];
        const cursosInvalidos = [];
        for (const courseId of cloneFilters.courseIds) {
            const targetCourse = cursos.find(c => String(c.courseId) === String(courseId));
            const targetEvaluationTypeId = educationLevels.find(c => String(c.educationLevelId) === String(targetCourse?.educationLevelId))?.evaluationTypeId;

            if (!targetCourse || !targetCourse.gradeId || !targetEvaluationTypeId || Number(targetEvaluationTypeId) !== Number(evaluationTypeId)) {
                cursosInvalidos.push(targetCourse?.name ?? `Curso ${courseId}`);
                continue;
            }
            if (!gradeIds.includes(targetCourse.gradeId)) {
                gradeIds.push(targetCourse.gradeId);
            }
        }

        if (gradeIds.length === 0) {
            Swal.fire(
                "No permitido",
                "Ninguno de los cursos seleccionados tiene un tipo de evaluación compatible con los logros a clonar.",
                "error"
            );
            return;
        }

        try {
            setCloneLoading(true);
            // Un solo request: todo el proceso de clonación (validar destinos y
            // crear los nuevos logros para cada combinación logro/curso) ocurre
            // en el backend mediante una única consulta masiva.
            const response = await logroService.cloneLogros({
                achievementIds: selectedRows.map(r => r.achievementId),
                schoolYearId: cloneFilters.schoolYearId,
                periodId: cloneFilters.periodId,
                schoolSubjectId: cloneFilters.schoolSubjectId,
                gradeIds,
            });

            if (response && response.message === "ok") {
                let mensaje = `Logros clonados exitosamente en ${gradeIds.length} curso(s) destino.`;
                if (cursosInvalidos.length > 0) {
                    mensaje += ` No se pudieron clonar en: ${cursosInvalidos.join(', ')}.`;
                }
                Swal.fire(
                    "¡Felicidades!",
                    mensaje,
                    "success"
                );
                setCloneModal(false);
                clearRowSelection();
                // Igual que al guardar un logro nuevo: sincroniza los filtros de la
                // búsqueda principal con el primer grado destino y busca ahí los
                // logros recién clonados.
                await searchAfterSave({
                    schoolYearId: cloneFilters.schoolYearId,
                    periodId: cloneFilters.periodId,
                    gradeId: gradeIds[0],
                    schoolSubjectId: cloneFilters.schoolSubjectId,
                    evaluationTypeId,
                });
            } else {
                Swal.fire(
                    "Ha ocurrido un error",
                    "Por favor intente más tarde",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error al clonar los logros:", error);
            Swal.fire(
                "Ha ocurrido un error",
                "Por favor intente más tarde",
                "error"
            );
        }
        setCloneLoading(false);
    };

    const customStyles = useCustomDataTableStyles();

    const handleFilterChange = (newFilters) => {
        // Actualiza el estado de filters con los nuevos valores
        setFilters(prev => ({
            ...prev,
            ...newFilters
        }));
    };

    return (
        <div className="student-table-container p-3">
            <h1>Gestión de Logros</h1>
            <p>Esta es la vista para gestionar los logros de los estudiantes.</p>

            <div className="row">
                    <JornadaAnioPeriodoNivelCursoAsig
                            callback={handleFilterChange}
                            ref={filteReference}
                            properties={
                                {
                                    className:'col-md-2 mb-2',
                                    id:'formTest',
                                    filtro:false
                                }
                            }
                        />

                    <div className="col-md-1 mb-1 margin-top-45">
                        <button onClick={(e)=>{ e.preventDefault(); fetchLogros(null); }} className="btn btn-primary ml-2">Buscar</button>
                    </div>
                    
            </div>

            {showLoading && <Loading />}

            {showSearch && (
            <> 
                    {!showLoading && (
                        <>
                            <div className="student-table-container p-3">
                                <div className="col-md-4 mb-3 d-flex align-items-end margin-top-48">
                                    <button className="btn-sm btn-Estudiante btn-NuevoEstudiante"  onClick={() => openAddingModal(null)} >
                                        Crear Nuevo Logro <i className="fa-solid fa-circle-plus"></i>
                                    </button>
                                    <button
                                        className="btn-sm btn-Estudiante btn-NuevoEstudiante ms-2"
                                        onClick={openCloneModal}
                                        disabled={selectedRows.length === 0}
                                    >
                                        Clonar Logros <i className="fa-solid fa-clone"></i>
                                    </button>
                                </div>

                                <div className="col-md-4 mb-2">
                                        <input
                                                type="text"
                                                placeholder="Buscar..."
                                                onChange={(e) => setFilterText(e.target.value)}
                                                className="form-control form-control-sm margin-top-45"
                                            />
                                </div>

                                <DataTable
                                    columns={columns}
                                    data={filteredItems}
                                    noDataComponent="No se encontraron logros que mostrar, por favor añadelos"
                                    className="students-datatable shadow-sm rounded"
                                    customStyles={customStyles}
                                    pagination
                                    fixedHeader
                                    paginationRowsPerPageOptions={[50, 100]}
                                    selectableRows
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggledClearRows}
                                />
                                
                            </div>
                        </>
                    )}
                </>
            )}
          
 <>
            <MDBModal show={fullscreenXlModal} setShow={setFullscreenXlModal} tabIndex='-1'>
                <MDBModalDialog size='xl' fullscreen='xl-down'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>{selectedLogro ? "Editar Logro" : "Agregar Logro"}</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {selectedLogro && (
                                <LogroForm
                                    key={formKey}
                                    logro={selectedLogro}
                                    initialFilters={paramLogros}
                                    onClose={(savedData)=>{
                                        toggleShow();
                                        searchAfterSave(savedData);
                                    }}
                                />
                            )}

                            {!selectedLogro && (
                                <LogroForm
                                    key={formKey}
                                    logro={null}
                                    initialFilters={paramLogros}
                                    onClose={(savedData)=>{
                                        toggleShow();
                                        searchAfterSave(savedData);
                                    }}
                                />
                            )}
                        </MDBModalBody>
                        <MDBModalFooter>
                        <button type='button' className='btn-footer-close btn-primary' onClick={toggleShow}>
                                    Cerrar
                        </button>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            </>

            <>
            <MDBModal show={cloneModal} setShow={setCloneModal} tabIndex='-1'>
                <MDBModalDialog size='xl' fullscreen='xl-down'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Clonar Logros</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={closeCloneModal} disabled={cloneLoading}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {cloneLoading && <Loading />}

                            {cloneModal && !cloneLoading && (
                                <>
                                    <p className="text-muted">
                                        Seleccione la jornada, año escolar, periodo, uno o varios cursos y la asignatura donde desea clonar los {selectedRows.length} logro(s) seleccionados.
                                    </p>
                                    <div className="row">
                                        <JornadaAnioPeriodoCursosMultiAsig
                                            callback={handleCloneFilterChange}
                                            ref={cloneFilterReference}
                                            properties={
                                                {
                                                    className:'col-md-4 mb-2',
                                                    id:'cloneFilters',
                                                    filtro:false
                                                }
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <button type='button' className='btn-footer-close btn-primary' onClick={closeCloneModal} disabled={cloneLoading}>
                                Cerrar
                            </button>
                            <button type='button' className='btn btn-primary' onClick={handleCloneSave} disabled={cloneLoading}>
                                {cloneLoading ? 'Guardando...' : 'Guardar'}
                            </button>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            </>
        </div>
    );
};

export default LogrosEstudiantes;
